import { Input, Tabs } from 'antd';
import { uniqBy } from 'lodash-es';
import { useEffect, useMemo, useState } from 'react';
import Member from './Member';
import SearchResult from './SearchResult';
import style from './Selector.module.less';

export type CheckedNodesType = {
  label: string;
  value: string;
  member_id: string;
  _original: any;
  children?: CheckedNodesType[];
};
export type SetCheckedNodesType = (
  checkedNodes: CheckedNodesType[],
  checked?: boolean,
) => void;

type SelectorProps = {
  value?: React.Key[];
  multiple?: boolean;
  onChange?: (checkedNodes: CheckedNodesType[]) => void;
};
const Selector = (props: SelectorProps) => {
  const [keyword, setKeyword] = useState<string>();
  const [checkedNodes, setCheckedNodes] = useState<CheckedNodesType[]>([]);
  useEffect(() => {
    props.onChange?.(checkedNodes);
  }, [checkedNodes]);
  const onSetCheckedNodes: SetCheckedNodesType = (checkedNodes, checked) => {
    if (checked === true) {
      setCheckedNodes((originalCheckedNodes) => {
        return uniqBy(originalCheckedNodes.concat(checkedNodes), 'member_id');
      });
    } else if (checked === false) {
      setCheckedNodes((originalCheckedNodes) => {
        return originalCheckedNodes.filter(
          ({ member_id }) => !checkedNodes.some((node) => member_id === node.member_id),
        );
      });
    } else {
      setCheckedNodes(checkedNodes);
    }
  };

  return (
    <div className={style.Selector}>
      <Input.Search
        placeholder={'搜索人员'}
        onSearch={(keyword) => {
          setKeyword(keyword);
        }}
      />
      <div className={'flex gap-x-[20px] h-[50vh]'}>
        <div
          className={
            'flex-1 border-[1px] border-solid border-[#d9d9d9] rounded-[10px] flex flex-col'
          }
        >
          <SearchResult
            keyword={keyword!}
            checkedNodes={checkedNodes}
            setCheckedNodes={onSetCheckedNodes}
          />
        </div>
        <div
          className={
            'flex-1 border-[1px] border-solid border-[#d9d9d9] rounded-[10px] flex flex-col'
          }
        >
          <Member
            value={props.value}
            checkedNodes={checkedNodes}
            setCheckedNodes={onSetCheckedNodes}
          />
        </div>
      </div>
    </div>
  );
};

export default Selector;
